import React from 'react';
import PropTypes from 'prop-types';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

// eslint-disable-next-line no-unused-vars
const UnderwritingsBlock = ({ strings, loading, contract }) => {
  const { underwritings } = contract;
  return (
    <div className="underwritings block">
      <Table className="table risk">
        <TableHead>
          <TableRow>
            <TableCell>{strings['contract.underwritings.table.risk.label'] || 'Risk'}</TableCell>
            <TableCell>
              {strings['contract.underwritings.table.subscriber_decision.label'] || 'Decision'}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {underwritings && Array.isArray(underwritings)
            ? underwritings.map(row => (
              <TableRow key={row.rec_name}>
                <TableCell component="th" scope="row">
                  {row.rec_name}
                </TableCell>
                <TableCell component="th" scope="row">
                  {row.automatic_decision
                      ? `${strings[
                          'contract.underwritings.table.subscriber_decision.status.pending.label'
                        ] || row.subscriber_decision} (auto)`
                      : strings[
                          'contract.underwritings.table.subscriber_decision.status.pending.label'
                        ] || row.subscriber_decision}
                </TableCell>
              </TableRow>
              ))
            : undefined}
        </TableBody>
      </Table>
    </div>
  );
};

UnderwritingsBlock.propTypes = {
  strings: PropTypes.objectOf(PropTypes.string),
  loading: PropTypes.objectOf(PropTypes.bool).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  contract: PropTypes.object.isRequired
};

UnderwritingsBlock.defaultProps = {
  strings: {}
};
export default UnderwritingsBlock;
